export default {
    path: 'zbhxrgs',
    component: () => import(/*webpackChunkName: 'bidding-zbhxrgs'*/ '@layout/empty'),
    children: [
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ding/zbhxr-gs/detail'),
            meta: {
                title: '中标候选人公示详情',
            },
        },
    ]
}